import React from "react";
import PropTypes from "prop-types";
import {BRCustomizedTooltip as Tooltip} from "./BRCustomizedTooltip";
import Link from "@material-ui/core/Link";
import BBIconExternalLink from "../../../assets/bbCustomIcons/BBIconExternalLink";

const BBExternalLink = ({children, href, tipText = null}) => {

    if(tipText) {
        return <Link target="_blank" rel="noopener" color="secondary" href={href}>
            <Tooltip title={tipText}>
                    <span>
                        {children}
                    </span>
            </Tooltip>
            <Tooltip title={`External Link to ${href}`}>
                    <span>
                        <BBIconExternalLink style={{fontSize: "smaller", margin:"3px", marginTop: 1}}/>
                    </span>
            </Tooltip>
        </Link>

    } else {
        return <Link target="_blank" rel="noopener" color="secondary" href={href}>
            {children}
            <Tooltip title={`External Link to ${href}`}>
                    <span>
                        <BBIconExternalLink style={{fontSize: "smaller", margin:"3px", marginTop: 1}}/>
                    </span>
            </Tooltip>
        </Link>
    }
};



BBExternalLink.propTypes = {
    href: PropTypes.string,
};

export default BBExternalLink;